export default __webpack_public_path__ + "media/images/icons/app-3-6ea76e5b0416bf4309c1733dc0fd8bad.png";